/**
 * NotificationSkeletonList — yükleniyor durumu (mevcut pulse deseni,
 * components/ui/skeleton.jsx kullanılarak).
 */
import { Skeleton } from '../ui/skeleton';

export default function NotificationSkeletonList({ count = 3 }) {
  return (
    <div className="flex flex-col gap-3 p-3" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex items-start gap-3">
          <Skeleton className="w-9 h-9 rounded-xl shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-3 w-3/4" />
            <Skeleton className="h-2.5 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
